export const navLinks = [
    {
        id: 1,
        title: "О\u00A0нас",
        path: '/#aboutus',
    },
    {
        id: 2,
        title: "Для кого",
        path: '/#forwhom',
    },
    {
        id: 3,
        title: "Команда",
        path: '/#ourcommand',
    },
    {
        id: 4,
        title: "Галерея",
        path: '/#gallery',
    },
    {
        id: 5,
        title: "Отзывы",
        path: '/#reviews',
    },
    {
        id: 6,
        title: "Вопросы",
        path: '/#faq',
    },
    {
        id: 7,
        title: "Положение о\u00A0хакатоне",
        path: '/Положение_о_научном_хакатоне_23_10_23.pdf',
        isFooter: true,
        target: "_blank",
        rel: "noopener noreferrer",
    },
]